import { useMemo, useState } from "react";
import VectorSource from "ol/source/Vector";
import VectorLayer from "ol/layer/Vector";
import Feature from "ol/Feature";
import { GeoJSON } from "ol/format";
import Style from "ol/style/Style";
import Fill from "ol/style/Fill";
import Geometry from "ol/geom/Geometry";

import { SwissMapLayers } from "components";

export interface UseVectorSourceResult {
  isError: boolean;
  isReady: boolean;
  layer: VectorLayer<VectorSource<Feature<Geometry>>>;
}

export function useVectorSource(src: string): UseVectorSourceResult {
  const [isError, setIsError] = useState(false);
  const [isReady, setIsReady] = useState(false);

  const source = useMemo(
    () =>
      new VectorSource({
        format: new GeoJSON({ dataProjection: "EPSG:2056" }),
        url: src,
      }),
    [src]
  );

  source.on("featuresloadend", () => setIsReady(true));
  source.on("featuresloaderror", () => setIsError(true));

  const layer = useMemo(
    () =>
      new VectorLayer({
        source,
        zIndex: SwissMapLayers.Vector,
        // Open Layers does not render features without styles, so
        // we need to define some transparent styles.
        style: () =>
          new Style({
            fill: new Fill({
              color: "rgba(0, 0, 0, 0)",
            }),
          }),
      }),
    [source]
  );

  return { layer, isReady, isError };
}
